export interface Brand {
  id?: number;
  code?: string;
  name?: string;
  active?: boolean;
}

export enum BrandCodes {
  SC = 'SC',
  GC = 'GC',
  MF = 'MF',
  SW = 'SW',
}
